import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import VpcBaseIndex from "../../base/vpc/index.vue";
import apiRequest from '../../../service/vpc/request';
import trustApiRequest from '../../../service/trust_vpc/request';
import { Button, ButtonGroup } from 'kpc/components/button';
import { Table, TableColumn } from 'kpc/components/table';
import TableWithPagination from "../../../components/TableWithPagination/index.vue";
import Tip from 'kpc/components/tip';
import Icon from 'kpc/components/icon';
import Input from 'kpc/components/input';
import { Select, Option } from 'kpc/components/select'
import * as _ from 'lodash'
import Pagination from 'kpc/components/pagination';
import { debounce } from "helpful-decorators";
import Tooltip from 'kpc/components/tooltip';
import Message from 'kpc/components/message';
import Spinner from 'kpc/components/spinner';

import { v4 as uuidv4 } from 'uuid';
import * as ipAddr from 'ip-address'
import getDhcp from "../../validator/getDhcp";
import rulesCheck from "../../validator/sgRulesCheck";

import vpcData from "../../../service/vpc/vpcData";
import whiteList from "../../../service/common/whiteList";
import commonApiRequest from "../../../service/common/apiRequest";
import CopyIcon from '../../../components/CopyIcon/index.vue'
import TableColumnEdit from "../../../components/TableColumnEdit/index.vue";
import KsSelect from '../../../components/KsSelect/index.vue';
import * as xlsxService from '../../../service/common/xlsx'

import ImportRuleDialog from "../../dialogs/import-rules/index.vue";
import ImportRuleDialogType from "../../dialogs/import-rules/_vue";

import RuleBatchRemoveDialog from "../../dialogs/batch-remove-rules/index.vue";
import RuleBatchRemoveDialogType from "../../dialogs/batch-remove-rules/_vue";

const reloadTimeout = 500;
const getTabName = (route: any): string => {
    if (route.name === 'groupDetailInstance' || route.name === 'trustGroupDetailInstance') {
        return route.params.type;
    }
    return route.name.replace(route.path.indexOf('trust-vpc') !== -1 ? 'trustGroupDetail' : 'groupDetail', '');
}
const formatPage = () => {
    return {
        total: 0,
        current: 1,
        limit: 5,
        limits: [5, 50, 100]
    }
}
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate',
]);

export class RuleItem {
    Direction = 'in';
    uniqId: string = '';
    RuleNumber: number = 100;
    Protocol: string = 'tcp';
    Policy: string = 'Accept';
    Priority: number = 1;
    RuleAction: string = 'allow';
    PortRangeFrom?: number;
    PortRangeTo?: number;
    ProtocolPort?: string[] = [];
    IcmpType?: string | number = '-1';
    IcmpCode?: string | number = 0;
    CidrBlock: string = '';
    CidrBlocks: string[] = [];
    RuleTag: string = '';
    SecurityGroupEntryId: string = '';
    editDisabled: boolean = false;
    isError: boolean = false;
    errorMsg: string = '';
    Description: string = '';
    LoadBalancerAclEntryId: string = '';

    constructor(direction: string) {
        this.uniqId = uuidv4().toString();
        this.SecurityGroupEntryId = uuidv4().toString();
        this.Direction = direction;
    }

    getParams() {
        let ruleItemParams: any = {
            Protocol: this.Protocol,
            Policy: this.Policy,
            Priority: this.Priority,
            CidrBlock: this.CidrBlock,
            CidrBlocks: this.CidrBlocks,
            Direction: this.Direction,
            PortRangeFrom: this.PortRangeFrom,
            ProtocolPort: this.ProtocolPort,
            RuleTag: this.RuleTag,
            Description: this.Description,
            SecurityGroupEntryId: this.SecurityGroupEntryId
        };

        switch (this.Protocol) {
            case 'ssh':
                ruleItemParams.Protocol = 'tcp';
                ruleItemParams.PortRangeFrom = 22;
                ruleItemParams.PortRangeTo = 22;
                break;
            case 'http':
                ruleItemParams.Protocol = 'tcp';
                ruleItemParams.PortRangeFrom = 80;
                ruleItemParams.PortRangeTo = 80;
                break;
            case 'https':
                ruleItemParams.Protocol = 'tcp';
                ruleItemParams.PortRangeFrom = 443;
                ruleItemParams.PortRangeTo = 443;
                break;
            case 'remote':
                ruleItemParams.Protocol = 'tcp';
                ruleItemParams.PortRangeFrom = 3389;
                ruleItemParams.PortRangeTo = 3389;
                break;
            case 'openvpn':
                ruleItemParams.Protocol = 'udp';
                ruleItemParams.PortRangeFrom = 1194;
                ruleItemParams.PortRangeTo = 1194;
                break;
            case 'ping':
                ruleItemParams.Protocol = 'icmp';
                ruleItemParams.IcmpCode = 0;
                ruleItemParams.IcmpType = 8;
                break;
            case 'tcp':
            case 'udp':
                ruleItemParams.Protocol = this.Protocol
                ruleItemParams.PortRangeFrom = Number(this.PortRangeFrom)
                ruleItemParams.PortRangeTo = Number(this.PortRangeTo)
                break;
            case 'icmp':
                ruleItemParams.Protocol = 'icmp';
                ruleItemParams.IcmpCode = Number(this.IcmpType == -1 ? '-1' : this.IcmpCode);
                ruleItemParams.IcmpType = Number(this.IcmpType);
            default:
                break;
        }
        return ruleItemParams;
    }
}

@Component({
    components: {
        Table,
        TableColumn,
        Tip,
        TableColumnEdit,
        Pagination,
        Input,
        Select,
        Option,
        CopyIcon,
        Button,
        ButtonGroup,
        Icon,
        Tooltip,
        Spinner,
        RuleBatchRemoveDialog,
        ImportRuleDialog,
        TableWithPagination,
        KsSelect
    },
    mixins: [VpcBaseIndex]
    // beforeRouteEnter(to, from, next) {
    //     next((vm: any) => {
    //         vm.type = to.params.type;
    //         vm.clean();
    //         vm.reload();
    //     })
    // },
    // beforeRouteUpdate(to, from, next) {
    //     let me: any = this;
    //     me.type = to.params.type;
    //     me.clean();
    //     me.reload();
    //     next();
    // }
})
export default class GroupDetailKecView extends Vue {
    type = "";
    region = "";
    vpcId = "";
    groupId = "";
    groupName = "";
    direct: string = "in";
    list: any[] = [];
    listOfChecked: any[] = [];
    page: any = formatPage();
    searchField = "NetworkInterfaceId";
    searchValue = "";
    vpcData: any = vpcData;
    inRuleList: any[] = [];
    outRuleList: any[] = [];
    interfaceEpcCount: number = 0;
    sgSupportEpcDeny = false;
    isDeleterule: boolean = true;
    isInRuleLock: boolean = false;
    isOutRuleLock: boolean = false;
    expandedKeys: any[] = [];
    showInRuleNoDataInfo: boolean = false;
    showOutRuleNoDataInfo: boolean = false;
    importRule: any = {
        show: false
    };
    timer: any = {
        timerPay: null
    };
    policyList: any[] = [
        { title: this.$trans(`允许`), value: "Accept" },
        { title: this.$trans(`拒绝`), value: "Drop" }
    ];
    protocolList: any[] = [
        { title: "IP", value: "ip" },
        { title: "ICMP", value: "icmp" },
        { title: "TCP", value: "tcp" },
        { title: "UDP", value: "udp" },
        { title: "ICMP ping", value: "ping" },
        { title: "TCP ssh(22)", value: "ssh" },
        { title: "TCP http(80)", value: "http" },
        { title: "TCP https(443)", value: "https" },
        { title: "UDP openvpn(1194)", value: "openvpn" },
        { title: this.$trans(`TCP Windows远程登录`), value: "remote" }
    ];
    IcmpTypeList: any[] = [
        { title: this.$trans(`全部协议`), value: "-1" },
        { title: "Echo Reply", value: "0" },
        { title: "Destination Unreachable", value: "3" },
        { title: "Source Quench", value: "4" },
        { title: "Redirect Message", value: "5" },
        { title: "Echo", value: "8" },
        { title: "Router Advertisement", value: "9" },
        { title: "Router Solicitation", value: "10" },
        { title: "Time Exceeded", value: "11" },
        { title: "Parameter Problem: Bad IP header", value: "12" },
        { title: "Timestamp", value: "13" },
        { title: "Timestamp Reply", value: "14" },
        { title: "Information Request", value: "15" },
        { title: "Information Reply", value: "16" },
        { title: "Address Mask Reques", value: "17" },
        { title: "Address Mask Reply", value: "18" },
        { title: "Traceroute", value: "30" }
    ];
    IcmpTypePortList: any[] = [];
    protocolPortList: any[] = [
        { title: "SSH（22）", value: "22" },
        { title: "Telnet（23）", value: "23" },
        { title: "HTTP（80）", value: "80" },
        { title: "HTTPS（443）", value: "443" },
        { title: "MS SQL（1433）", value: "1433" },
        { title: "Oracle（1521）", value: "1521" },
        { title: "MySQL（3306）", value: "3306" },
        { title: "RDP（3389）", value: "3389" },
        { title: "PostgreSQL（5432）", value: "5432" },
        { title: "Redis（6379）", value: "6379" },
        { title: "ALL（1-65535）", value: "1-65535" }
    ];
    // cidrBlockList: any[] = [
    //     { title: "0.0.0.0/0", value: "0" },
    //     { title: "10.0.0.0/8", value: "8" },
    //     { title: "172.16.0.0/12", value: "12" },
    //     { title: "192.168.0.0/16", value: "16" },
    //     { title: "::/0", value: "999" }
    // ];
    icmpTypes: any[] = [];
    ipVersion: string = "ipv4";
    currVpcSupportIpv6: boolean = false;
    inNotValid: boolean = true;
    outNotValid: boolean = true;

    repeatedRulesWithDesc: any[] = [];
    repeatedRulesNoDesc: any[] = [];
    noneRepeatedRuleIndex: any[] = [];
    allRepeatedRules: any[] = [];
    rulesNoDescArr: any[] = [];
    originArrParam: any[] = [];
    repeatedRuleCheck: any = {
        show: false
    };
    arrParamInNew: any[] = [];
    arrParamOutNew: any[] = [];
    origionRulues: any[] = [];
    vpcList: any[] = [];
    isClickHouse: boolean = false;
    isDns: boolean = false;
    newRulesData: any[] = [];
    restSelectTool: any[] = [
        { title: "不合并", value: 0 },
        { title: "按端口合并", value: 1 },
        { title: "按IP合并", value: 2 }
    ];
    restSelect = 0;
    inCloneRuleList: any[] = [];
    outCloneRuleList: any[] = [];

    // kec、epc、kci的table初始化
    initPage = {
        total: 0,
        current: 1,
        limit: 5,
        limits: [5, 50, 100]    
    };

    clean() {
        this.list = [];
        this.listOfChecked = [];
        this.searchField = "NetworkInterfaceId";
        this.searchValue = "";
        this.page = formatPage();
    }

    get parent(): any {
        return this.$parent;
    }

    get isGlobalGroup() {
        return this.parent.SecurityGroupType === 'global';
    }

    get cidrBlockList() {
        const blockList = [
            { title: "0.0.0.0/0", value: "0" },
            { title: "10.0.0.0/8", value: "8" },
            { title: "172.16.0.0/12", value: "12" },
            { title: "192.168.0.0/16", value: "16" },
        ];
        if (!this.isGlobalGroup) {
            blockList.push({ title: "::/0", value: "999" })
        }

        return blockList;        
    }

    get regionSupportDeny() {
        let me: any = this;
        return whiteList.check("sgSupportDeny", me.region);
    }

    get regionAvailable():any {
        const me:any = this;
        if (!me.region) {
            return true;
        }
        let type = "securityGroupsSearchSortExport";
        return whiteList.check(type, me.region);
    }

    get regionSupportNewUi() {
        // let me: any = this;
        // return whiteList.check("sgSupportNewUi", me.region);
        return true;
    }

    get inRuleListSorted() {
        const me = this;
        if (!me.isInRuleLock) {
            me.inRuleList.sort((a: any, b: any) => {
                if (a.Priority > b.Priority) {
                    return 1;
                } else if (a.Priority === b.Priority) {
                    if (a.Policy != b.Policy) {
                        if (a.Policy == "Accept") {
                            return 1;
                        } else {
                            return -1;
                        }
                    } else {
                        let ProtocolA = 0;
                        let ProtocolB = 0;
                        for (let i = 0; i < 4; ++i) {
                            if (a.Protocol.includes(me.protocolList[i].value)) {
                                ProtocolA = i;
                            }
                            if (b.Protocol.includes(me.protocolList[i].value)) {
                                ProtocolB = i;
                            }
                        }
                        if (ProtocolA > ProtocolB) {
                            return 1;
                        } else if (ProtocolA == ProtocolB) {
                            if (a.Protocol.includes('tcp') || a.Protocol.includes('udp') ) {
                                if (a.PortRangeFrom > b.PortRangeFrom) {
                                    return 1;
                                } else if (a.PortRangeFrom < b.PortRangeFrom) {
                                    return -1;
                                }
                            }
                            if (a.Protocol.includes('icmp')) {
                                let indexA = 0;
                                let indexB = 0;
                                for(let i=0; i< me.IcmpTypePortList.length; ++i) {
                                    if (me.IcmpTypePortList[i].value == `${a.IcmpType || 0}-${a.IcmpCode || 0}`) {
                                        indexA = i;
                                    }
                                    if (me.IcmpTypePortList[i].value == `${b.IcmpType || 0}-${b.IcmpCode || 0}`) {
                                        indexB = i;
                                    }
                                }

                                if (indexA > indexB) {
                                    return 1;
                                } else if (indexA < indexB) {
                                    return -1;
                                }
                            }

                            const timeA = new Date(me.getCreateTime(a.CreateTime)).getTime();
                            const timeB = new Date(me.getCreateTime(b.CreateTime)).getTime();
                            return timeA > timeB ? -1 : 1;
                        } else {
                            return -1;
                        }
                    }
                } else {
                    return -1;
                }
            })
        }
        
        return me.inRuleList;
    }

    get outRuleListSorted() {
        const me = this;
        if (!me.isOutRuleLock) {
            me.outRuleList.sort((a: any, b: any) => {
                if (a.Priority > b.Priority) {
                    return 1;
                } else if (a.Priority === b.Priority) {
                    if (a.Policy != b.Policy) {
                        if (a.Policy == "Accept") {
                            return 1;
                        } else {
                            return -1;
                        }
                    } else {
                        let ProtocolA = 0;
                        let ProtocolB = 0;
                        for (let i = 0; i < 4; ++i) {
                            if (a.Protocol.includes(me.protocolList[i].value)) {
                                ProtocolA = i;
                            }
                            if (b.Protocol.includes(me.protocolList[i].value)) {
                                ProtocolB = i;
                            }
                        }
                        if (ProtocolA > ProtocolB) {
                            return 1;
                        } else if (ProtocolA == ProtocolB) {
                            if (a.Protocol.includes('tcp') || a.Protocol.includes('udp') ) {
                                if (a.PortRangeFrom > b.PortRangeFrom) {
                                    return 1;
                                } else if (a.PortRangeFrom < b.PortRangeFrom) {
                                    return -1;
                                }
                            }
                            if (a.Protocol.includes('icmp')) {
                                let indexA = 0;
                                let indexB = 0;
                                for(let i=0; i< me.IcmpTypePortList.length; ++i) {
                                    if (me.IcmpTypePortList[i].value == `${a.IcmpType || 0}-${a.IcmpCode || 0}`) {
                                        indexA = i;
                                    }
                                    if (me.IcmpTypePortList[i].value == `${b.IcmpType || 0}-${b.IcmpCode || 0}`) {
                                        indexB = i;
                                    }
                                }

                                if (indexA > indexB) {
                                    return 1;
                                } else if (indexA < indexB) {
                                    return -1;
                                }
                            }

                            const timeA = new Date(me.getCreateTime(a.CreateTime)).getTime();
                            const timeB = new Date(me.getCreateTime(b.CreateTime)).getTime();
                            return timeA > timeB ? -1 : 1;
                        } else {
                            return -1;
                        }
                        //(timeA > timeB ? 1 : -1);
                    }
                } else {
                    return -1;
                }
            });
        }
        return me.outRuleList;
    }

    get request() {
        return this.isTrustVpc ? trustApiRequest : apiRequest
    }

    public beforeRouteEnter(to: any, from: any, next: any) {
        next((vm: any) => {
            vm.type = to.params.type;
            vm.clean();
            vm.reload();
        });
    }

    public beforeRouteUpdate(to: any, from: any, next: any) {
        let me: any = this;
        me.type = to.params.type;
        me.clean();
        me.reload();
        next();
    }

    // @Watch("restSelect")
    // restSelectWatch(val: Number) {
    //     let me: any = this;
    //     let ruleList: any[] = [];
    //     if (me.type == "inRule") {
    //         ruleList = me.inRuleList;
    //     } else {
    //         ruleList = me.outRuleList;
    //     }
    //     if (val === 1) {
    //         //按端口合并
    //         me.mergeList(ruleList, 'port');
    //     } else if (val === 2) {
    //         //按IP合并
    //         me.mergeList(ruleList, 'ip');
    //     } else {
    //         me.resetList();
    //     }
    // }

    // mergeList(ruleList: any, param: string) {
    //     let me: any = this;
    //     let mergeRuleList: any[] = [];
    //     let setData: any[] = [];
    //     _.forEach(ruleList, item => {
    //         let mergeId =
    //             item.Priority + "-" +
    //             item.Policy + "-" +
    //             item.Protocol + "-" +
    //             item.PortRangeFrom + "-" +
    //             item.PortRangeTo + "-" +
    //             item.IcmpType + "-" +
    //             item.IcmpCode + "-" +
    //             item.RuleTag + "-" +
    //             item.Description;
    //         const idx = _.findIndex(setData, (item) => { return item === mergeId});
    //         if (idx > -1) {
    //             if (mergeRuleList[idx].PortRangeFrom != item.PortRangeFrom) {
    //                 mergeRuleList[idx].PortRangeFrom = mergeRuleList[idx].PortRangeFrom + ',' + item.PortRangeFrom;
    //             }
    //             if (mergeRuleList[idx].CidrBlock != item.CidrBlock) {
    //                 mergeRuleList[idx].CidrBlocks.push(item.CidrBlock);
    //             }
    //         } else {
    //             setData.push(mergeId);
    //             item.CidrBlocks = [item.CidrBlock];
    //             mergeRuleList.push(item);
    //         }
    //     });

    //     if (me.type == "inRule") {
    //         me.inRuleList = mergeRuleList;
    //     } else {
    //         me.outRuleList = mergeRuleList;
    //     }
    // }

    // resetList() {
    //     let me: any = this;
    //     if (me.type == "inRule") {
    //         me.inRuleList = _.cloneDeep(me.inCloneRuleList);
    //     } else {
    //         me.outRuleList = _.cloneDeep(me.outCloneRuleList);
    //     }
    // }

    getSgSupportEpcDeny() {
        let me: any = this;
        // 安全组deny规则是否支持epc。1、不支持；2、支持
        commonApiRequest
            .DescribeQuotaByName({
                Region: me.region,
                QuotaName: "quota_vpc_securitygroupepcdeny"
            })
            .done((data: any) => {
                if (data && data.QuotaMax) {
                    this.sgSupportEpcDeny = data.QuotaMax == 2 ? true : false;
                }
            });
    }

    showPublicIpInfoSet(row: any) {
        if (row.PublicIpInfoSet && row.PublicIpInfoSet.length) {
            const hasPublicIpData = _.filter(row.PublicIpInfoSet, (ipInfo) => { return ipInfo.PublicIp });
            if (!hasPublicIpData.length) {
                return true;
            }
        }
        return false;
    }

    networkInterfaceListChangePage(page: any) {
        this.page.current = page.current;
        this.page.limit = page.limit;
        (this.type === 'inRule') ||(this.type === 'outRule') && this.reload();
    }

    networkInterfaceListSearch() {
        this.reload();
    }

    validateChangeNetworkConfig() {
        let list = this.list;
        let listOfChecked = this.listOfChecked;
        if (listOfChecked.length === 0) {
            return {
                disabled: true,
                msg: ""
            };
        }

        if (listOfChecked.length > 1) {
            return {
                disabled: true,
                msg: "不支持批量操作"
            };
        }

        let hasIpv4 = false;
        let hasIpv6 = false;
        let hasIpv6Public = false;
        _.forEach(listOfChecked, vifId => {
            let vif = _.find(list, ["NetworkInterfaceId", vifId]);
            if (vif.Ipv6PublicIpAddress) {
                hasIpv6 = true;
            } else {
                hasIpv4 = true;
            }
            if (vif.Ipv6Public) {
                hasIpv6Public = true;
            }
        });

        if (hasIpv4 && hasIpv6) {
            return {
                disabled: true,
                msg: "不能同时更换IPv4和IPv6的云服务器"
            };
        }

        if (hasIpv6 && listOfChecked.length > 1) {
            return {
                disabled: true,
                msg: "IPv6子网的云服务器不支持批量更换网络"
            };
        }

        if (hasIpv6Public) {
            return {
                disabled: true,
                msg: "您需要先到【弹性IP-ipv6列表】关闭ipv6公网访问"
            };
        }

        return {
            disabled: false,
            msg: ""
        };
    }

    goToCloseIPv6Public(row: any) {
        this.$router.push({
            name: "ipv6ip"
        });
    }

    openDeleteRuleDialog(param: any) {
        let me: any = this;
        let ruleList: any[] = [];
        if (param == "inRule") {
            ruleList = me.inRuleList;
        } else {
            ruleList = me.outRuleList;
        }
        let dialog: any = me.$refs
            .RuleBatchRemoveDialog as RuleBatchRemoveDialogType;

        //剔除新增规则未添加的数据
        let listOfChecked = _.filter(me.listOfChecked, item => {
            return item;
        });

        let selectRuleList = _.map(
            listOfChecked,
            (SecurityGroupEntryId: string) => {
                return _.find(ruleList, [
                    "SecurityGroupEntryId",
                    SecurityGroupEntryId
                ]);
            }
        );
        //恢复数据源 排除未添加新规则
        if (!selectRuleList.length) {
            me.deleteCacheRuleInPage(param);
            return;
        }

        dialog.open(me.region, param, selectRuleList, () => {
            me.reload();
        });
    }

    //复制当前规则
    copyRuleInPage(type: any, scope: any, index: any) {
        let me: any = this;
        const rulesItem = me.addRuleItem(type);

        _.each(scope, (value, key) => {
            if (
                key !== "SecurityGroupEntryId" &&
                key !== "LoadBalancerAclEntryId" &&
                key !== "RuleAction" &&
                key !== "RuleNumber" &&
                key !== "editDisabled" &&
                key !== "uniqId"
            ) {
                rulesItem[key] = _.cloneDeep(value);
            }
        });
        // this.isInRuleLock = true;
        // let rulesItem = _.cloneDeep(scope);
        // rulesItem.uniqId = uuidv4().toString();
        if (scope.Protocol == "icmp") {
            if (scope.IcmpType == -1) {
                rulesItem.IcmpType = "-1";
            } else {
                rulesItem.IcmpType =
                    _.toString(rulesItem.IcmpType) +
                    "-" +
                    _.toString(rulesItem.IcmpCode);
            }
            if (scope.IcmpCode == -1) {
                rulesItem.IcmpCode = 0;
            }
        } else if (scope.Protocol == "tcp" || scope.Protocol == "udp") {
            if (rulesItem.PortRangeFrom === rulesItem.PortRangeTo) {
                rulesItem.ProtocolPort = [_.toString(rulesItem.PortRangeFrom)];
            } else {
                rulesItem.ProtocolPort = [
                    rulesItem.PortRangeFrom + "-" + rulesItem.PortRangeTo
                ];
            }
        }
        rulesItem.CidrBlocks = rulesItem.CidrBlock.length
            ? rulesItem.CidrBlock.split(",")
            : [];
        // if (type == "inRule") {
        //     // me.inRuleList.unshift(rulesItem);
        //     me.inRuleList[0] = rulesItem;
        // } else {
        //     me.outRuleList.unshift(rulesItem);
        // }
    }

    //删除安全组规则接口
    deleteRuleInPage(type: any, scope: any, index: any) {
        let me: any = this;
        if (!scope || !scope.SecurityGroupEntryId) {
            return;
        }
        let dialog: any = me.$refs
            .RuleBatchRemoveDialog as RuleBatchRemoveDialogType;
        dialog.open(me.region, type, [scope], () => {
            me.reload();
        });

        // me.timer.timerPay && clearTimeout(me.timer.timerPay);
        // me.timer.timerPay = setTimeout(() => {
        //     apiRequest
        //         .DeleteSecurityGroupEntrys({
        //             Region: me.region,
        //             groupId: me.groupId,
        //             ids: scope.SecurityGroupEntryId
        //         })
        //         .done((data: any) => {
        //             if (data && data.Return) {
        //                 Message.success(me.$trans(`删除成功`));
        //             }
        //             me.reload();
        //         })
        //         .always((e: any) => {
        //             console.log(e);
        //             me.reload();
        //         });
        // }, 400);
    }

    isEqualRule(arr: any[]) {
        let index: any[] = []; //所有重复的索引 [2,4,5,1,0,0]
        let newArr: any[] = []; //[3,2,2]  重复的后面的放进去
        let json: any = {}; //{2:{index:0,value:2},3:{index:1,value:3}}
        let jsonFilter: any = {};
        let indexArr: any[] = []; //对index进行去重

        let jsonNew: any = {}; //{2:[0],3:[1,2],1:[3],2:[4,5]}
        let arrAll: any[] = [];
        _.forEach(arr, (item, index) => {
            if (!jsonNew[item]) {
                let arrh = [];
                arrh.push(index);
                jsonNew[item] = arrh;
            } else {
                jsonNew[item].push(index);
            }
        });

        for (let i in jsonNew) {
            if (jsonNew[i].length > 1) {
                arrAll.push(jsonNew[i]);
            }
        }

        for (let i = 0; i < arr.length; i++) {
            if (!json[arr[i]]) {
                json[arr[i]] = {
                    index: i,
                    value: arr[i]
                };
            } else {
                index.push(i);
                newArr.push(arr[i]);
            }
        }
        for (let i = 0; i < newArr.length; i++) {
            index.push(json[newArr[i]]["index"]);
        }
        for (let i = 0; i < index.length; i++) {
            if (!jsonFilter[index[i]]) {
                jsonFilter[index[i]] = true;
                indexArr.push(index[i]);
            }
        }
        let obj = {
            arrAll: arrAll,
            indexArr: indexArr.sort()
        };
        return obj;
    }

    formatRule(type: any) {
        let me: any = this;
        let cloneRulesData: any[] = [];
        if (type == "in") {
            cloneRulesData = me.inRuleList;
        } else {
            cloneRulesData = me.outRuleList;
        }

        const data: any = _.cloneDeep(cloneRulesData[0]);
        if (data) {
            let splitData: any[] = [];
            let tempData: any = _.cloneDeep(data);
            tempData.CidrBlock = data.CidrBlocks.join();
            if (data.Protocol == "icmp") {
                tempData.IcmpType =
                    data.IcmpType == "-1" ? "-1" : data.IcmpType.split("-")[0];
                tempData.IcmpCode =
                    data.IcmpType == "-1" ? "-1" : data.IcmpType.split("-")[1];
                splitData.push(tempData);
            } else if (data.Protocol == "tcp" || data.Protocol == "udp") {
                if (data.ProtocolPort && data.ProtocolPort.length) {
                    _.forEach(data.ProtocolPort, subitem => {
                        let temp: any = _.cloneDeep(data);
                        const splitPort = _.toString(subitem).split("-");
                        temp.CidrBlock = data.CidrBlocks.join();
                        temp.PortRangeFrom =
                            splitPort.length > 1 ? splitPort[0] : subitem;
                        temp.PortRangeTo =
                            splitPort.length > 1 ? splitPort[1] : subitem;
                        splitData.push(temp);
                    });
                }
            } else {
                splitData.push(tempData);
            }
            me.newRulesData = splitData;
            cloneRulesData[0].CidrBlock = data.CidrBlocks.join();
            if (!data.ProtocolPort || !data.ProtocolPort.length) {
                cloneRulesData[0].PortRangeFrom = "";
                cloneRulesData[0].PortRangeTo = "";
            }
        }

        //清空提示
        let arrNew: any[] = [];
        _.forEach(cloneRulesData, (item, index) => {
            item.PortRangeFrom = _.trim(item.PortRangeFrom);
            item.PortRangeTo = _.trim(item.PortRangeTo);
            item.CidrBlock = _.trim(item.CidrBlock);
            item.Description = _.trim(item.Description);
            item.RuleTag = _.trim(item.RuleTag);
            arrNew.push(item);
        });

        cloneRulesData = rulesCheck.sgRulesCheck(arrNew, me, getDhcp);

        var onOff = false;
        let expandedKeys: any[] = [];
        _.forEach(cloneRulesData, (item, index) => {
            if (item.isError) {
                expandedKeys.push(item.SecurityGroupEntryId);
                onOff = true;
            }
        });
        me.expandedKeys = expandedKeys;

        const arrParam = this.getArrParam(cloneRulesData);

        //判断规则是否完全一样 就不需要判断字段筛选出去
        var rulesCloneDeep = _.cloneDeep(arrParam);
        var isEqual: any[] = [];
        _.forEach(rulesCloneDeep, function(item, id) {
            delete item.Description;
            delete item.Index;
            delete item.RuleName;
            delete item.Range;
            delete item.SecurityGroupEntryId;
            delete item.RuleTag;
            if (item.IcmpType) {
                item.IcmpType = Number(item.IcmpType);
            }
            if (item.IcmpCode) {
                item.IcmpCode = Number(item.IcmpCode);
            }
            if (item.PortRangeFrom) {
                item.PortRangeFrom = item.PortRangeFrom.toString();
            }
            if (item.PortRangeTo) {
                item.PortRangeTo = item.PortRangeTo.toString();
            }

            isEqual.push(JSON.stringify(item));
        });

        var arrParamNew: any[] = [];
        const equalRuleResult = me.isEqualRule(isEqual);

        //判断重复规则的 只保留一条
        if (equalRuleResult.indexArr.length > 0) {
            var arr = _.cloneDeep(arrParam);

            //先把所有重复的索引的元素删掉
            _.forEach(arr, (item, index) => {
                if (!_.includes(equalRuleResult.indexArr, index)) {
                    arrParamNew.push(item);
                }
            });

            //[[0,1],[2,5,6]]
            _.forEach(equalRuleResult.arrAll, (item, index) => {
                var col = item[0];
                _.forEach(arrParam, (item, index) => {
                    if (index == col) {
                        arrParamNew.push(item);
                    }
                });
            });
        } else {
            arrParamNew = arrParam;
        }

        //  筛选 arrParams编辑过的才传给后端
        // var filterArrParams: any[] = [];
        // _.forEach(arrParamNew, function(item) {
        //     if (item.SecurityGroupEntryId) {
        //         var originJson = _.find(me.origionRulues, [
        //             "SecurityGroupEntryId",
        //             item.SecurityGroupEntryId
        //         ]);
        //         var isSame = true;
        //         _.forEach(item, function(v, k) {
        //             if (item[k] != originJson[k]) {
        //                 isSame = false;
        //             }
        //         });
        //         if (!isSame) {
        //             filterArrParams.push(item);
        //         }
        //     } else {
        //         filterArrParams.push(item);
        //     }
        // });

        if (type == "in") {
            // me.arrParamInNew = filterArrParams;
            me.inRuleList = cloneRulesData;
        } else {
            // me.arrParamOutNew = filterArrParams;
            me.outRuleList = cloneRulesData;
        }

        // 如果有重复的规则，那么将重复的规则展示在前端页面让用户来筛选
        // if (equalRuleResult.arrAll.length > 0) {
        // onOff = true;
        // }

        if (type == "in") {
            if (onOff) {
                me.inNotValid = true;
                return;
            } else {
                me.inNotValid = false;
            }
        } else {
            if (onOff) {
                me.outNotValid = true;
                return;
            } else {
                me.outNotValid = false;
            }
        }
    }

    getArrParam(rules: any[]) {
        const arrParam: any[] = [];
        const push = (
            item: any,
            protocol: string,
            from?: number,
            to?: number
        ) => {
            const obj: any = {
                CidrBlock: item.CidrBlock,
                Direction: item.Direction,
                Protocol: protocol,
                PortRangeFrom: from,
                PortRangeTo: to,
                RuleTag: item.RuleTag,
                Description: item.Description || null
            };
            if (!_.isUndefined(from) && !_.isUndefined(to)) {
                obj.PortRangeFrom = from;
                obj.PortRangeTo = to;
            }

            if (item.SecurityGroupEntryId) {
                obj.SecurityGroupEntryId = item.SecurityGroupEntryId;
            }
            arrParam.push(obj);

            return obj;
        };
        _.forEach(rules, item => {
            switch (item.Protocol) {
                case "ssh":
                    if (item.CidrBlock) {
                        push(item, "tcp", 22, 22);
                    }
                    break;
                case "http":
                    if (item.CidrBlock) {
                        push(item, "tcp", 80, 80);
                    }
                    break;
                case "https":
                    if (item.CidrBlock) {
                        push(item, "tcp", 443, 443);
                    }
                    break;
                case "remote":
                    if (item.CidrBlock) {
                        push(item, "tcp", 3389, 3389);
                    }
                    break;
                case "healthy":
                    if (item.reverse) {
                        push(item, "tcp", 1, 65535);
                    }
                    break;
                case "ping":
                    if (item.CidrBlock) {
                        push(item, "icmp", 0, 8);
                    }
                    break;
                case "openvpn":
                    if (item.CidrBlock) {
                        push(item, "udp", 1194, 1194);
                    }
                    break;
                case "ip":
                    if (item.CidrBlock) {
                        push(item, item.Protocol);
                    }
                    break;
                case "tcp":
                case "udp":
                    if (
                        item.CidrBlock != "" &&
                        item.PortRangeFrom != "" &&
                        item.PortRangeTo != ""
                    ) {
                        push(
                            item,
                            item.Protocol,
                            item.PortRangeFrom,
                            item.PortRangeTo
                        );
                    }
                    break;
                case "icmp":
                    if (item.CidrBlock) {
                        const obj = push(item, item.Protocol);
                        _.extend(obj, {
                            IcmpCode: Number(item.IcmpCode),
                            IcmpType: Number(item.IcmpType)
                        });
                        if (item.IcmpType == "-1") {
                            obj.IcmpType = "-1";
                            obj.IcmpCode = "-1";
                        }
                    }
                    break;
            }
        });

        return arrParam;
    }

    addCacheRuleInPage(type: any, srcRules: any) {
        let me: any = this;
        let rules: any[] = [];
        let ruleList: any = [];
        if (type == "inRule") {
            ruleList = me.inRuleList;
            me.formatRule("in");
            if (me.inNotValid) {
                Message.error(me.$trans(`有规则错误，请修正规则后再提交！`));
                return;
            }
        } else {
            ruleList = me.outRuleList;
            me.formatRule("out");
            if (me.outNotValid) {
                Message.error(me.$trans(`有规则错误，请修正规则后再提交！`));
                return;
            }
        }

        // if (!_.trim(srcRules.CidrBlock)) {
        //     if (me.ipVersion === "ipv4") {
        //         srcRules.CidrBlock = "0.0.0.0/0";
        //     }
        //     if (me.ipVersion === "ipv6") {
        //         srcRules.CidrBlock = "::/0";
        //     }
        // }

        if (me.newRulesData && me.newRulesData.length) {
            _.forEach(me.newRulesData, item => {
                let ruleItem: any = {
                    SecurityGroupId: me.groupId,
                    CidrBlock: _.trim(item.CidrBlock),
                    Policy: _.trim(item.Policy),
                    Priority: _.trim(item.Priority),
                    Direction: type == "inRule" ? "in" : "out",
                    Protocol: _.trim(item.Protocol),
                    PortRangeFrom: _.trim(item.PortRangeFrom) || null,
                    PortRangeTo: _.trim(item.PortRangeTo) || null,
                    RuleTag: _.trim(item.RuleTag),
                    Description: _.trim(item.Description) || null
                };

                switch (item.Protocol) {
                    case "ssh":
                        ruleItem.Protocol = "tcp";
                        ruleItem.PortRangeFrom = 22;
                        ruleItem.PortRangeTo = 22;
                        break;
                    case "http":
                        ruleItem.Protocol = "tcp";
                        ruleItem.PortRangeFrom = 80;
                        ruleItem.PortRangeTo = 80;
                        break;
                    case "https":
                        ruleItem.Protocol = "tcp";
                        ruleItem.PortRangeFrom = 443;
                        ruleItem.PortRangeTo = 443;
                        break;
                    case "remote":
                        ruleItem.Protocol = "tcp";
                        ruleItem.PortRangeFrom = 3389;
                        ruleItem.PortRangeTo = 3389;
                        break;
                    case "openvpn":
                        ruleItem.Protocol = "udp";
                        ruleItem.PortRangeFrom = 1194;
                        ruleItem.PortRangeTo = 1194;
                        break;
                    case "ping":
                        ruleItem.Protocol = "icmp";
                        ruleItem.IcmpCode = 0;
                        ruleItem.IcmpType = 8;
                        break;
                    case "tcp":
                    case "udp":
                        ruleItem.Protocol = item.Protocol;
                        ruleItem.PortRangeFrom = Number(item.PortRangeFrom);
                        ruleItem.PortRangeTo = Number(item.PortRangeTo);
                        break;
                    case "icmp":
                        ruleItem.Protocol = "icmp";
                        ruleItem.IcmpCode = Number(
                            item.IcmpType == -1 ? "-1" : item.IcmpCode
                        );
                        ruleItem.IcmpType = Number(item.IcmpType);
                    default:
                        break;
                }

                rules.push(ruleItem);
            });
        }

        if (!rules.length) {
            return;
        }

        me.BatchAuthorizeSecurityGroupEntry(rules);
    }

    deleteCacheRuleInPage(type: any, scope: any) {
        let me: any = this;
        me.reload();
    }

    updateProtocols(protocols: any[]) {
        this.protocolList = protocols;
    }

    getIcmpTypes() {
        return vpcData.getIcmpTypes();
    }

    addRuleItem(type: any) {
        let me: any = this;
        let direct = type === "inRule" ? "in" : "out";
        // if (me.ipVersion === "ipv4") {
        //     item.CidrBlock = "0.0.0.0/0";
        // }
        // if (me.ipVersion === "ipv6") {
        //     item.CidrBlock = "::/0";
        // }
        if (type == "inRule") {
            if (!me.isInRuleLock) {
                let item = new RuleItem(direct);

                if (me.inRuleList.length > 0) {
                    let lastRuleNumber = _.last(this.inRuleList)!.RuleNumber;
                    item.RuleNumber = lastRuleNumber + 10;
                }
                me.inRuleList.unshift(item);
                me.isInRuleLock = true;

                return item;
            }
            return me.inRuleList[0];
        } else {
            if (!me.isOutRuleLock) {
                let item = new RuleItem(direct);

                if (me.outRuleList.length > 0) {
                    let lastRuleNumber = _.last(this.outRuleList)!.RuleNumber;
                    item.RuleNumber = lastRuleNumber + 10;
                }
                me.outRuleList.unshift(item);
                me.isOutRuleLock = true;

                return item;
            }
            return me.outRuleList[0];
        }
    }

    importRules(type: any) {
        let me: any = this;
        me.importRule.show = true;
        let dialog: any = me.$refs.ImportRuleDialog as ImportRuleDialogType;
        const origionRulues = type == "inRule" ? me.inRuleList : me.outRuleList;
        dialog.open(
            me.region,
            me.currVpcSupportIpv6,
            me.interfaceEpcCount,
            me.sgSupportEpcDeny,
            me.type,
            origionRulues,
            (importRules: any[]) => {
                if (importRules && importRules.length) {
                    me.validImportData(type, importRules);
                    //保存数据
                    me.BatchReplaceSecurityGroupEntry(importRules, type);
                }
            }
        );
    }

    validImportData(type: any, data: any) {
        let me: any = this;
        let importRules = _.cloneDeep(data);
        _.forEach(importRules, item => {
            if (item.Protocol == "icmp") {
                if (item.IcmpType == -1) {
                    item.IcmpType = "-1";
                } else {
                    item.IcmpType =
                        _.toString(item.IcmpType) +
                        "-" +
                        _.toString(item.IcmpCode);
                }
                if (item.IcmpCode == -1) {
                    item.IcmpCode = 0;
                }
            } else if (item.Protocol == "tcp" || item.Protocol == "udp") {
                if (item.PortRangeFrom === item.PortRangeTo) {
                    item.ProtocolPort = [_.toString(item.PortRangeFrom)];
                } else {
                    item.ProtocolPort = [
                        item.PortRangeFrom + "-" + item.PortRangeTo
                    ];
                }
            }
            item.CidrBlocks = item.CidrBlock.length
                ? item.CidrBlock.split(",")
                : [];
        });

        if (type == "inRule") {
            me.inRuleList = importRules;
        } else {
            me.outRuleList = importRules;
        }

        if (type == "inRule") {
            me.formatRule("in");
            if (me.inNotValid) {
                Message.error(me.$trans(`有规则错误，请修正规则后再提交！`));
                return;
            }
        } else {
            me.formatRule("out");
            if (me.outNotValid) {
                Message.error(me.$trans(`有规则错误，请修正规则后再提交！`));
                return;
            }
        }
    }

    //批量新增安全组规则接口
    BatchAuthorizeSecurityGroupEntry(rules: any[]) {
        let me: any = this;

        if (!me.regionSupportDeny) {
            _.forEach(rules, item => {
                delete item.Policy;
                delete item.Priority;
            });
        }

        me.timer.timerPay && clearTimeout(me.timer.timerPay);
        me.timer.timerPay = setTimeout(() => {
            let urlParams = {
                Region: me.region
            };
            let jsonParams = {};
            let optionParams = {
                isJSON: true
            };

            if (!me.regionSupportNewUi) {
                jsonParams = {
                    SecurityGroupId: me.groupId,
                    Params: rules,
                    RemoveParams: []
                };
                // apiRequest
                this.request
                    .BatchEditSecurityGroupEntry(
                        [urlParams, jsonParams],
                        optionParams
                    )
                    .done(function(data: any) {
                        let fails: any[] = [];
                        _.forEach(data.SecurityGroupEntrySet, item => {
                            if (!item.IsSuccess) {
                                fails.push(item.Message);
                            }
                        });
                        if (fails.length) {
                            Message.error(fails.join());
                        } else {
                            Message.success(me.$trans(`添加成功`));
                        }
                        me.reload();
                    })
                    .always(() => {
                        me.reload();
                    });
            } else {
                jsonParams = {
                    SecurityGroupId: me.groupId,
                    SecurityGroupEntrySet: rules
                };
                // apiRequest
                this.request
                    .BatchAuthorizeSecurityGroupEntry(
                        [urlParams, jsonParams],
                        optionParams
                    )
                    .done(function(data: any) {
                        if (data.Return) {
                            Message.success(me.$trans(`添加成功`));
                        }
                        me.reload();
                    })
                    .always(() => {
                        me.reload();
                    });
            }
        }, 400);
    }

    //批量替换安全组规则接口
    BatchReplaceSecurityGroupEntry(rules: any, type: any) {
        let me: any = this;
        let newRules: any[] = [];
        let ruleItem: any = {};

        _.forEach(rules, item => {
            ruleItem = {
                SecurityGroupId: me.groupId,
                Policy: _.trim(item.Policy),
                Priority: _.trim(item.Priority),
                CidrBlock: _.trim(item.CidrBlock),
                Direction: type == "inRule" ? "in" : "out",
                Protocol: _.trim(item.Protocol),
                PortRangeFrom:
                    _.trim(item.PortRangeFrom) == "-" ||
                    _.trim(item.PortRangeFrom) == ""
                        ? null
                        : _.trim(item.PortRangeFrom),
                PortRangeTo:
                    _.trim(item.PortRangeTo) == "-" ||
                    _.trim(item.PortRangeTo) == ""
                        ? null
                        : _.trim(item.PortRangeTo),
                RuleTag: _.trim(item.RuleTag),
                Description: _.trim(item.Description) || null
            };

            switch (item.Protocol) {
                case "ssh":
                    ruleItem.Protocol = "tcp";
                    ruleItem.PortRangeFrom = 22;
                    ruleItem.PortRangeTo = 22;
                    break;
                case "http":
                    ruleItem.Protocol = "tcp";
                    ruleItem.PortRangeFrom = 80;
                    ruleItem.PortRangeTo = 80;
                    break;
                case "https":
                    ruleItem.Protocol = "tcp";
                    ruleItem.PortRangeFrom = 443;
                    ruleItem.PortRangeTo = 443;
                    break;
                case "remote":
                    ruleItem.Protocol = "tcp";
                    ruleItem.PortRangeFrom = 3389;
                    ruleItem.PortRangeTo = 3389;
                    break;
                case "openvpn":
                    ruleItem.Protocol = "udp";
                    ruleItem.PortRangeFrom = 1194;
                    ruleItem.PortRangeTo = 1194;
                    break;
                case "ping":
                    ruleItem.Protocol = "icmp";
                    ruleItem.IcmpCode = 0;
                    ruleItem.IcmpType = 8;
                    break;
                case "tcp":
                case "udp":
                    ruleItem.Protocol = item.Protocol;
                    ruleItem.PortRangeFrom = Number(item.PortRangeFrom) || null;
                    ruleItem.PortRangeTo = Number(item.PortRangeTo) || null;
                    break;
                case "icmp":
                    ruleItem.Protocol = "icmp";
                    ruleItem.IcmpCode = Number(
                        item.IcmpType == -1 ? "-1" : item.IcmpCode
                    );
                    ruleItem.IcmpType = Number(item.IcmpType);
                default:
                    break;
            }

            newRules.push(ruleItem);
        });

        if (!me.regionSupportDeny) {
            _.forEach(newRules, item => {
                delete item.Policy;
                delete item.Priority;
            });
        }

        me.timer.timerPay && clearTimeout(me.timer.timerPay);
        me.timer.timerPay = setTimeout(() => {
            let urlParams = {
                Region: me.region
            };
            let jsonParams = {};
            let optionParams = {
                isJSON: true
            };

            jsonParams = {
                SecurityGroupId: me.groupId,
                Params: newRules,
                RemoveParams: []
            };
            // apiRequest
            this.request
                .BatchEditSecurityGroupEntry(
                    [urlParams, jsonParams],
                    optionParams
                )
                .done(function(data: any) {
                    let fails: any[] = [];
                    _.forEach(data.SecurityGroupEntrySet, item => {
                        if (!item.IsSuccess) {
                            fails.push(item.Message);
                        }
                    });
                    if (fails.length) {
                        Message.error(fails.join());
                    } else {
                        Message.success(me.$trans(`添加成功`));
                    }
                    me.reload();
                })
                .always(() => {
                    me.reload();
                });

            // if (!me.regionSupportNewUi) {
            //     jsonParams = {
            //         SecurityGroupId: me.groupId,
            //         Params: newRules,
            //         RemoveParams: []
            //     };
            //     apiRequest
            //         .BatchEditSecurityGroupEntry(
            //             [urlParams, jsonParams],
            //             optionParams
            //         )
            //         .done(function(data: any) {
            //             let fails: any[] = [];
            //             _.forEach(data.SecurityGroupEntrySet, item => {
            //                 if (!item.IsSuccess) {
            //                     fails.push(item.Message);
            //                 }
            //             });
            //             if (fails.length) {
            //                 Message.error(fails.join());
            //             } else {
            //                 Message.success(me.$trans(`添加成功`));
            //             }
            //             me.reload();
            //         })
            //         .always(() => {
            //             me.reload();
            //         });
            // } else {
            //     jsonParams = {
            //         SecurityGroupId: me.groupId,
            //         SecurityGroupEntrySet: newRules
            //     };
            //     apiRequest
            //         .BatchReplaceSecurityGroupEntry(
            //             [urlParams, jsonParams],
            //             optionParams
            //         )
            //         .done(function(data: any) {
            //             if (data.Return) {
            //                 Message.success(me.$trans(`添加成功`));
            //             }
            //             me.reload();
            //         })
            //         .always(() => {
            //             me.reload();
            //         });
            // }
        }, 400);
    }

    // 新加
    getCreateTime(time:string) {
        const me = this;

        if (time && time.includes(',')) {
            const temp = time.split(',')
            const numberTime = temp.map((ele: string) => {
                return new Date(ele).getTime();
            });
            let tempInd = 0;
            let maxTime = 0;
            numberTime.forEach((ele: number, ind: number) => {
                if (ele > maxTime) {
                    maxTime = ele;
                    tempInd = ind
                }
            })
            return temp[tempInd];
        }
        return time;

    }
    
    exportRules(type: any) {
        let me: any = this;
        let rows: any[] = [];

        if (!me.regionSupportDeny) {
            rows = [
                [
                    me.$trans(`协议`),
                    me.$trans(`行为`),
                    me.$trans(`起始端口`),
                    me.$trans(`结束端口`),
                    type == "inRule" ? me.$trans(`源IP`) : me.$trans(`目标IP`),
                    me.$trans("创建时间"),
                    "TAG",
                    me.$trans(`备注`)
                ]
            ];
        } else {
            rows = [
                [
                    me.$trans(`优先级`),
                    me.$trans(`访问权限`),
                    me.$trans(`协议`),
                    me.$trans(`起始端口`),
                    me.$trans(`结束端口`),
                    type == "inRule" ? me.$trans(`源IP`) : me.$trans(`目标IP`),
                    me.$trans("创建时间"),
                    "TAG",
                    me.$trans(`备注`)
                ]
            ];
        }

        let rules: any[] = [];
        if (type == "inRule") {
            rules = me.inRuleListSorted;
        } else {
            rules = me.outRuleListSorted;
        }

        //排除未添加新规则
        rules = _.filter(rules, item => {
            return item.SecurityGroupEntryId;
        });

        if (!rules || !rules.length) {
            Message.error(this.$trans(`不能为空`));
            return;
        }
        _.forEach(rules, item => {
            let startPort = "";
            if (item.Protocol == "ip") {
                startPort = "-";
            } else if (item.Protocol == "icmp") {
                // let IcmpType = _.find(me.IcmpTypeList, ['value', item.IcmpType.toString()]);
                // startPort = !_.isEmpty(IcmpType) ? IcmpType.title : '';
                startPort = item.IcmpType;
            } else if (item.Protocol == "tcp" || item.Protocol == "udp") {
                startPort = item.PortRangeFrom;
            } else if (item.Protocol == "ping") {
                startPort = "Echo";
            } else if (item.Protocol == "ssh") {
                startPort = "22";
            } else if (item.Protocol == "http") {
                startPort = "80";
            } else if (item.Protocol == "https") {
                startPort = "443";
            } else if (item.Protocol == "openvpn") {
                startPort = "1194";
            } else if (item.Protocol == "remote") {
                startPort = "3389";
            }

            let endPort = "";
            if (item.Protocol == "ip") {
                endPort = "-";
            } else if (item.Protocol == "icmp") {
                // let IcmpCode = _.find(me.icmpTypes[item.IcmpType], ['value', item.IcmpCode]) || {};
                // endPort = !_.isEmpty(IcmpCode) ? IcmpCode.text : '';
                endPort = item.IcmpCode;
            } else if (item.Protocol == "tcp" || item.Protocol == "udp") {
                endPort = item.PortRangeTo;
            } else if (item.Protocol == "ping") {
                endPort = "Echo request";
            } else if (item.Protocol == "ssh") {
                endPort = "22";
            } else if (item.Protocol == "http") {
                endPort = "80";
            } else if (item.Protocol == "https") {
                endPort = "443";
            } else if (item.Protocol == "openvpn") {
                endPort = "1194";
            } else if (item.Protocol == "remote") {
                endPort = "3389";
            } else if (item.Protocol == "healthy") {
                endPort = "65535";
            }
            if (!me.regionSupportDeny) {
                rows.push([
                    item.Protocol,
                    me.$trans(`允许`),
                    startPort,
                    endPort,
                    item.CidrBlock,
                    item.CreateTime,
                    item.RuleTag,
                    item.Description
                ]);
            } else {
                rows.push([
                    item.Priority,
                    item.Policy,
                    item.Protocol,
                    startPort,
                    endPort,
                    item.CidrBlock,
                    item.CreateTime,
                    item.RuleTag,
                    item.Description
                ]);
            }
        });

        xlsxService.download("secgroup_rules", rows);
    }

    // 导出：云服务器信息、罗晋属服务器信息、容器实例信息
    exportServer(type: string) {
        let rows: any[] = [];
        let tableName = ''
        const me = this
        if(me.list.length === 0) return Message.info('列表为空')
        if (type === 'kec') {
            tableName = me.$trans('云服务器信息列表')
            rows = [
                [
                    me.$trans('内网IP'),
                    'EIP',
                    me.$trans('网卡名称'),
                    me.$trans('IPV6 IP'),
                    me.$trans('网卡类型'),
                    me.$trans('云服务器名称'),
                    me.$trans('网卡MAC'),
                    me.$trans('网卡ID'),
                    me.$trans('云服务器ID'),
                ]
            ]
        } else if (type === 'epc') {
            tableName = me.$trans('裸金属服务器信息列表')
            rows = [
                [
                    me.$trans('内网IP'),
                    'EIP',
                    me.$trans('网卡类型'),
                    me.$trans('裸金属服务器名称'),
                    me.$trans('网卡MAC'),
                    me.$trans('网卡ID'),
                    me.$trans('裸金属服务器ID'),
                ]
            ]
        } else {
            tableName = me.$trans('容器实例信息列表')
            rows = [
                [
                    me.$trans('内网IP'),
                    me.$trans('网卡类型'),
                    me.$trans('实例名称'),
                    me.$trans('网卡MAC'),
                    me.$trans('网卡ID'),
                    me.$trans('实例ID'),
                ]
            ]
        }
        _.forEach(me.list, item => {
            if (type === 'kec') {
                rows.push([
                    item.PrivateIpAddress,
                    item.PublicIpInfoSet[0].PublicIp || '-',
                    item.NetworkInterfaceName,
                    item.Ipv6PublicIpAddress || '-',
                    item.NetworkInterfaceType === 'primary' ? me.$trans('主网卡') : me.$trans('辅网卡'),
                    item.InstanceName,
                    item.MacAddress,
                    item.NetworkInterfaceId,
                    item.InstanceId,
                ])
            }else if (type === 'epc') {
                rows.push([
                    item.PrivateIpAddress,
                    item.PublicIpInfoSet[0].PublicIp || '-',
                    item.NetworkInterfaceType === 'primary' ? me.$trans('主网卡') : me.$trans('辅网卡'),
                    item.InstanceName,
                    item.MacAddress,
                    item.NetworkInterfaceId,
                    item.InstanceId,
                ])
            } else {
                rows.push([
                    item.PrivateIpAddress,
                    item.NetworkInterfaceType === 'primary' ? me.$trans('主网卡') : me.$trans('辅网卡'),
                    item.InstanceName,
                    item.MacAddress,
                    item.NetworkInterfaceId,
                    item.InstanceId,
                ])
            }
        })

        xlsxService.download(tableName, rows);

    }

    gotoEditRule(type: any) {
        let me: any = this;
        this.$router.push({
            name: me.isTrustVpc ? "trustGroupEditRule" : "groupEditRule",
            params: {
                type: type,
                region: me.region,
                vpcId: me.vpcId,
                groupId: me.groupId
            }
        });
    }

    gotoMangerServer(type: any) {
        let me: any = this;
        this.$router.push({
            name: me.isTrustVpc ? "trustGroupMangerServer" : "groupMangerServer",
            params: {
                type: type,
                region: me.region,
                vpcId: me.vpcId,
                groupId: me.groupId,
                groupName: encodeURIComponent(me.groupName)
            }
        });
    }

    remarksChangeHandler(scope: any, inputValue: string) {
        inputValue = _.trim(inputValue);
        const remark = scope.Description;
        const sgEntryIdArr = scope.SecurityGroupEntryId.split(",");
        let urlParams = {
            Region: this.region
        };
        let jsonParams = {};
        let optionParams = {
            isJSON: true
        };
        if (inputValue && inputValue !== remark) {
            jsonParams = {
                SecurityGroupEntryId: sgEntryIdArr,
                Description: inputValue
            };
            // apiRequest
            this.request
                .ModifySecurityGroupEntry(
                    [urlParams, jsonParams],
                    optionParams
                )
                .done((data: any) => {
                    if (data && data.length) {
                        scope.Description = inputValue;
                        Message.success(this.$trans(`备注修改完成`));
                    }
                });
        }
    }

    DescribeSecurityGroups() {
        let me: any = this;
        return new Promise(resolve => {
            // apiRequest
            this.request
                .DescribeSecurityGroups({
                    Region: me.region,
                    "SecurityGroupId.1": me.groupId
                })
                .done((data: any) => {
                    let detail = _.get(data, "SecurityGroupSet[0]", {});
                    let entrySet = _.get(detail, "SecurityGroupEntrySet");
                    me.isClickHouse = detail.UserTag != "console" ? true : false;
                    me.isDns = detail.UserTag == 'dns' ? true : false;
                    //查询绑定EPC的数量，如果绑定了EPC则不可选择 访问权限的 拒绝选项；
                    me.interfaceEpcCount = detail.InterfaceEpcCount || 0;

                    me.groupName = detail.SecurityGroupName;

                    // 按优先级排序：从上至下，数字越小越靠前
                    // 优先级相同，访问权限不同：拒绝 > 允许
                    entrySet = _.orderBy(
                        entrySet,
                        ["Priority", "Policy"],
                        ["asc", "desc"]
                    );

                    const inRuleList =
                        _.filter(entrySet, item => {
                            return item.Direction == "in";
                        }) || [];
                    me.inRuleList = inRuleList;
                    me.inCloneRuleList = _.cloneDeep(inRuleList);
                    const outRuleList =
                        _.filter(entrySet, item => {
                            return item.Direction == "out";
                        }) || [];
                    me.outRuleList = outRuleList;
                    me.outCloneRuleList = _.cloneDeep(outRuleList);
                    let arr: any[] = [];
                    _.forEach(entrySet, function(item) {
                        if (item.RuleTag) {
                            item.editDisabled = false;
                        }
                        arr.push(item);
                    });

                    _.forEach(arr, item => {
                        if (item.Protocol == "icmp") {
                            if (
                                item.IcmpType == null ||
                                item.IcmpType == "-1"
                            ) {
                                item.IcmpType = "-1";
                                item.IcmpCode = "-1";
                            }
                        }
                    });

                    me.origionRulues = arr;
                    // 生成icmp协议对应的协议端口列表
                    let icmpTypePort: any[] = [];
                    _.forEach(me.IcmpTypeList, item => {
                        _.forEach(me.icmpTypes[item.value], subitem => {
                            if (item.value == "-1") {
                                icmpTypePort.push({
                                    title: item.title,
                                    value: "-1"
                                });
                            } else {
                                icmpTypePort.push({
                                    title: item.title + " - " + subitem.text,
                                    value: item.value + "-" + subitem.value
                                });
                            }
                        });
                    });
                    me.IcmpTypePortList = icmpTypePort;

                    if (!me.vpcId || !me.vpcList.length) {
                        return;
                    }
                    me.direct = me.type === "inRule" ? "in" : "out";

                    const currVpc = _.find(me.vpcList, ["VpcId", me.vpcId]);

                    if (
                        currVpc &&
                        currVpc.Ipv6CidrBlockAssociationSet &&
                        currVpc.Ipv6CidrBlockAssociationSet.length > 0
                    ) {
                        me.ipVersion = "ipv6";
                        me.currVpcSupportIpv6 = true;
                    } else {
                        me.ipVersion = "ipv4";
                        me.currVpcSupportIpv6 = false;
                    }

                    if (!me.inRuleList.length) {
                        me.showInRuleNoDataInfo = true;
                    }

                    if (!me.outRuleList.length) {
                        me.showOutRuleNoDataInfo = true;
                    }

                    resolve(detail);
                })
                .fail(() => {
                    resolve({});
                });
        });
    }

    @debounce(reloadTimeout)
    async reload() {
        let me: any = this;
        if (me.type === "inRule") {
            me.isInRuleLock = false;
        } else {
            me.isOutRuleLock = false;
        }
        me.expandedKeys = [];
        me.inRuleList = [];
        me.outRuleList = [];

        me.getSgSupportEpcDeny();
        me.DescribeSecurityGroups();

        let paramType = me.type;

        //出入站规则列表不支持分页
        if (_.includes(["inRule", "outRule"], paramType)) {
            return;
        }
        // 由于导出的需要，kec、epc、kci的数据要一次全拿到
        let MaxResults = (this.type === 'inRule' || this.type === 'outRule') ? this.page.limit : 10000
        let data: any =
            (await this.$parent.getNetworkInterfaceList(
                paramType,
                this.page.current,
                MaxResults,
                this.searchField,
                this.searchValue
            )) || {};
        this.list = data.NetworkInterfaceSet || [];
        this.listOfChecked = [];
        this.page.total = data.TotalCount || 0;
        let pageNum = Math.ceil(this.page.total / this.page.limit);
        if (pageNum < this.page.current) {
            this.page.current = 1;
        }
    }

    async mounted() {
        let me: any = this;
        let params = me.$route.params;
        me.region = params.region;
        me.groupId = params.groupId;
        me.vpcId = params.vpcId;
        me.type = params.type;
        me.icmpTypes = vpcData.icmpTypes;
        me.reload();
    }
}
